import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { getIntegrations } from "redux/selector";
import { Dialog } from "component/shared/dialog";
import { DialogTitle } from "component/shared/dialog/title";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { IntegrationType } from "type/integration-type";
import { User } from "model/user";
import { TopProducerLtsIntegration } from "./top-producer-lts";
import { CustomLtsIntegration } from "./custom-lts";
import { ZapierNewLeadIntegration } from "./zapier-new-lead";
import { LeadAggregationIntegration } from "./lead-aggregation";
import { ZillowTechConnectIntegration } from "./zillow-tech-connect";
import { EmailCalendarIntegration } from "./email-calendar";
import { GoogleLoginIntegration } from "./google-login";
import { WixIntegration } from "./wix-app";
import { ClientEventWebhookIntegration } from "./client-event-webhook";
import { FollowUpBossIntegration } from "./follow-up-boss";

const mapStateToProps = (state: RootState) => {
	return {
		integrations: getIntegrations(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles>
{
	open: boolean;
	onClose: Function;
	onFubConnect?: (id: number) => void;
	user: User;
}

class Component extends React.Component<Props, any> {

	public render() {
		const { open, onClose, onFubConnect, classes = {}, user, integrations } = this.props;
		const integrationTypes = IntegrationType
			.values()
			.filter(integrationType => integrationType.permitted(user))
			.filter(integrationType => !integrationType.facebook)
			.filter(integrationType => {
				const count = integrations.filter(integration => integration.integrationType === integrationType).length;
				return integrationType.limit > count;
			})
			.sort((a, b) => a.name.localeCompare(b.name))
		;

		return (
			<Dialog open={open} onClose={() => onClose()} scroll="paper">
				<DialogTitle title="Add Integration" onClose={() => onClose()} />
				<Mui.DialogContent>
					{integrationTypes.map((integrationType) => (
						<Mui.Accordion key={integrationType.id}>
							<Mui.AccordionSummary
								expandIcon={
									<FeatherIcon>
										<Icons.ChevronDown />
									</FeatherIcon>
								}
							>
								{integrationType.iconUrl && (
									<Mui.CardMedia className={classes.icon} image={integrationType.iconUrl} />
								)}
								<Mui.Typography>{integrationType.name}</Mui.Typography>
							</Mui.AccordionSummary>
							<Mui.AccordionDetails>
								{integrationType.topProducerLts && (
									<TopProducerLtsIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.customLts && (
									<CustomLtsIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.zapierNewLead && (
									<ZapierNewLeadIntegration integrationType={integrationType} />
								)}
								{integrationType.leadAggregation && (
									<LeadAggregationIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.zillowTechConnect && (
									<ZillowTechConnectIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.emailCalendar && (
									<EmailCalendarIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.googleLogin && (
									<GoogleLoginIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.wixApp && (
									<WixIntegration integrationType={integrationType} onClose={onClose}/>
								)}
								{integrationType.clientEventWebhook && (
									<ClientEventWebhookIntegration integrationType={integrationType} onClose={onClose} />
								)}
								{integrationType.followUpBoss && (
									<FollowUpBossIntegration integrationType={integrationType} onClose={onClose} onFubConnect={onFubConnect} />
								)}
							</Mui.AccordionDetails>
						</Mui.Accordion>
					))}
				</Mui.DialogContent>
			</Dialog>
		);
	}
}

export const AddDialog = withStyles(connect(
	mapStateToProps,
	mapDispatchToProps,
)(Component), styles);
